export class ForbiddenError extends Error {
  readonly name: string

  readonly __proto__: ForbiddenError

  constructor(message = "Forbidden") {
    const prototype = new.target.prototype
    super(message)
    this.__proto__ = prototype
    this.name = "FORBIDDEN_ERROR"
  }
}
